import { getBackendBaseUrl } from './config';
import { getAuthToken } from './auth';

export type PmProjectRow = {
  id: number;
  name: string;
  contract_number?: string | null;
  status?: string | null;
};

function pmProjectLabel(p: PmProjectRow): string {
  const name = (p.name || '').trim();
  const code = (p.contract_number || '').trim();
  if (code && name) return `${code} - ${name}`;
  return name || code || `پروژه ${p.id}`;
}

/** لیست پروژه از API مدیریت پروژه (Sanctum یا session) */
export async function fetchProjectManagerProjects(): Promise<PmProjectRow[]> {
  const base = getBackendBaseUrl();
  const url = `${base || ''}/api/project-manager/projects?per_page=500`;
  const headers: Record<string, string> = { Accept: 'application/json' };
  const token = getAuthToken();
  const pmToken = typeof window !== 'undefined' ? window.localStorage.getItem('pm_auth_token') : null;
  if (token) headers.Authorization = `Bearer ${token}`;
  else if (pmToken) headers.Authorization = `Bearer ${pmToken}`;

  try {
    const res = await fetch(url, { headers, credentials: 'include' });
    if (!res.ok) return [];
    const json = (await res.json()) as { data?: PmProjectRow[] | { data?: PmProjectRow[] } };
    if (Array.isArray(json.data)) return json.data;
    if (json.data && Array.isArray((json.data as { data?: PmProjectRow[] }).data)) {
      return (json.data as { data: PmProjectRow[] }).data;
    }
    return [];
  } catch {
    return [];
  }
}

export { pmProjectLabel };
